import { render, staticRenderFns } from "./PermitList.vue?vue&type=template&id=8047846c&"
import script from "./PermitList.vue?vue&type=script&lang=js&"
export * from "./PermitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports